<template>
  <DBox
    :id="'cmp-booking-artist-related_users'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('responsible_agent_string')}`"
    @add_click="adduserClick"
  >
    <div class="dt-list v2">
      <div
        class="dt-list-item"
        v-for="user of relatedUsers"
        :key="user.artist_user_id"
      >
        <div class="dt-list-item--body">
          <div class="dt-list-item--text">
            {{ user.user_name }}
          </div>
          <div class="dt-list-item--icon">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                @click="e => onuserDelete(user)"
                class="dt-icon v5 s1"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </DBox>
</template>

<script>
export default {
  props: {
    relatedUsers: {
      type: Array,
      default: () => []
    },
    selectedArtist: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {};
  },
  computed: {},
  methods: {
    adduserClick: function(event) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_user",
          section: "artist",
          artist_id: this.selectedArtist.artist_id
        }
      });
    },
    onuserDelete: function(user) {
      this.$emit("userDelete", user);
    },
    onuserEdit: function(user) {}
  }
};
</script>

<style lang="scss" scoped>
.dt-list-item--text {
  // TODO! Change the max-width solution - This is only for 1920px window width. This is not responsive for all window sizes
  flex: 2.8;
}
</style>
